<form class="job-selection-dialog-content" (keyup.enter)="startJob()">
    <cds-form-group layout="vertical">
        <ng-container *ngrxLet="sourceLayers$ as sourceLayers; suspenseTpl: loadingTemplate">
            <cds-select layout="vertical">
                <label>Target layer</label>
                <select
                    name="target-layer-selection"
                    [ngModel]="selectedTargetLayer"
                    (ngModelChange)="selectTargetLayer($event)"
                >
                    <ng-container *ngFor="let layer of sourceLayers">
                        <option [ngValue]="layer">{{ layer.name }}</option>
                    </ng-container>
                </select>
            </cds-select>
            <app-multi-select-box
                [title]="'Source layers'"
                [items]="sourceLayers"
                (selected)="selectSourceLayers($event)"
            ></app-multi-select-box>
        </ng-container>
        <ng-template #loadingTemplate>
            <div class="center-content">
                <div class="default-loading-indicator loading-container">
                    <cds-progress-circle></cds-progress-circle>
                </div>
            </div>
        </ng-template>
        <div *ngIf="siblingDatasets!.length > 1">
            <cds-checkbox>
                <label>Run the job on datasets in the same folder</label>
                <input
                    id="runBatchJob"
                    type="checkbox"
                    name="runBatchJob"
                    [(ngModel)]="runBatchJob"
                />
            </cds-checkbox>
            <ul class="batch-datasets" [class.show]="runBatchJob">
                <li *ngFor="let dataset of siblingDatasets">
                    {{ dataset }}
                </li>
            </ul>
        </div>
    </cds-form-group>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
    <cds-button size="sm" (click)="startJob()" [disabled]="!canStart">Start Job</cds-button>
</div>
